module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_17.892f595d.pdf";